import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

export interface ErrorDetail {
  message: string;
  translationKey?: string;
  errorId?: string;
  service?: string;
  methodName?: string;
  statusCode: number;
  showTechnicalDetails?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor() { }


  extractErrorDetail(error: HttpErrorResponse): ErrorDetail {
    const statusCode = error.status;
    let errorDetail: ErrorDetail = {
      message: '',
      translationKey: this.getHttpStatusTranslationKey(statusCode),
      statusCode: statusCode,
      showTechnicalDetails: false
    };

    if (error.error) {
      if (typeof error.error === 'object') {
        if (error.error.errorMessage) {
          errorDetail.message = error.error.errorMessage;
          errorDetail.errorId = error.error.errorId;
          errorDetail.service = error.error.service;
          errorDetail.methodName = error.error.methodName;
          errorDetail.showTechnicalDetails = true;
        }
        else if (error.error.message) {
          errorDetail.message = error.error.message;
          errorDetail.showTechnicalDetails = true;
        }
        else if (error.error.error) {
          errorDetail.message = error.error.error;
        }
      } else if (typeof error.error === 'string') {
        errorDetail.message = error.error;
      }
    }

    return errorDetail;
  }

  private getHttpStatusTranslationKey(statusCode: number): string {
    const translationKeys: { [key: number]: string } = {
      400: 'KNOWLEDGE_FEATURE.ERRORS.BAD_REQUEST',
      401: 'KNOWLEDGE_FEATURE.ERRORS.UNAUTHORIZED',
      403: 'KNOWLEDGE_FEATURE.ERRORS.FORBIDDEN',
      404: 'KNOWLEDGE_FEATURE.ERRORS.NOT_FOUND',
      500: 'KNOWLEDGE_FEATURE.ERRORS.INTERNAL_SERVER',
      502: 'KNOWLEDGE_FEATURE.ERRORS.BAD_GATEWAY',
      503: 'KNOWLEDGE_FEATURE.ERRORS.SERVICE_UNAVAILABLE',
      504: 'KNOWLEDGE_FEATURE.ERRORS.GATEWAY_TIMEOUT'
    };

    return translationKeys[statusCode] || 'KNOWLEDGE_FEATURE.ERRORS.GENERIC';
  }

  getGenericErrorKey(): string {
    return 'KNOWLEDGE_FEATURE.TOASTS.QUESTION_ERROR';
  }

  formatErrorMessageWithId(message: string, errorId?: string): string {
    if (errorId) {
      return `${message} (ID: ${errorId})`;
    }
    return message;
  }

  logError(errorDetail: ErrorDetail, context?: string): void {
    const logMessage = `[${context || 'Error'}] Status: ${errorDetail.statusCode}, Message: ${errorDetail.message}`;
    console.error(logMessage);
    if (errorDetail.errorId) {
      console.error(`Error ID: ${errorDetail.errorId}`);
    }
    if (errorDetail.methodName) {
      console.error(`Method: ${errorDetail.service}.${errorDetail.methodName}`);
    }
  }
}
